import { IPickerListItem } from "@livechat/design-system-react-components";

export const NOT_DETECTED_KEY = "none";

const NOT_DETECTED_OPTION: IPickerListItem = {
  key: NOT_DETECTED_KEY,
  name: "Not detected",
};

const DETECTED_HEADER: IPickerListItem = {
  groupHeader: true,
  key: "detected-header",
  name: "detected",
};

const OTHER_LANGUAGES_HEADER: IPickerListItem = {
  groupHeader: true,
  key: "all-langs-header",
  name: "other languages",
};

const createLanguageOptionFactory =
  (allLanguages: Record<string, string>) =>
  (lang: string): IPickerListItem => ({
    key: lang,
    name: `${allLanguages[lang]} (${lang.toLocaleUpperCase()})`,
  });

export const createOptions = (
  allLanguages: Record<string, string>,
  detectedLanguageKeys: string[]
): IPickerListItem[] => {
  const allLanguageKeys = Object.keys(allLanguages);
  const hasDetectedLanguages = detectedLanguageKeys.length > 0;

  const languageOptionFactory = createLanguageOptionFactory(allLanguages);
  const detectedLanguagesOptions = hasDetectedLanguages
    ? [DETECTED_HEADER, ...detectedLanguageKeys.map(languageOptionFactory)]
    : [];

  const undetectedLanguageKeys = allLanguageKeys.filter(key => !detectedLanguageKeys.includes(key));

  const otherLanguagesOptions = hasDetectedLanguages
    ? [OTHER_LANGUAGES_HEADER, ...undetectedLanguageKeys.map(languageOptionFactory)]
    : [...allLanguageKeys.map(languageOptionFactory)];

  return [NOT_DETECTED_OPTION, ...detectedLanguagesOptions, ...otherLanguagesOptions];
};
